class DlPageComplianceInformationLL extends HTMLElement {
  constructor() {
    super();
    this.tabs = [];
    this.panels = [];
    this.tabList = null;
    this.previousButton = null;
    this.nextButton = null;
    this.activeIndex = 0;
    this.updateOverflowState = this.updateOverflowState.bind(this);
  }

  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    this.tabList = this.querySelector('[data-tab-list]');
    this.previousButton = this.querySelector('[data-tab-action="previous"]');
    this.nextButton = this.querySelector('[data-tab-action="next"]');

    if (!this.tabs.length) return;

    this.dataset.initialized = 'true';
    this.activeIndex = Math.max(0, this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true'));

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activateTab(index));
      tab.addEventListener('keydown', (event) => this.handleTabKeydown(event, index));
    });

    this.previousButton?.addEventListener('click', () => this.activateTab(this.activeIndex - 1, true));
    this.nextButton?.addEventListener('click', () => this.activateTab(this.activeIndex + 1, true));
    this.tabList?.addEventListener('scroll', this.updateOverflowState, { passive: true });
    window.addEventListener('resize', this.updateOverflowState, { passive: true });

    requestAnimationFrame(this.updateOverflowState);
  }

  disconnectedCallback() {
    this.tabList?.removeEventListener('scroll', this.updateOverflowState);
    window.removeEventListener('resize', this.updateOverflowState);
  }

  activateTab(index, focus = false) {
    if (index < 0 || index >= this.tabs.length || index === this.activeIndex) return;

    this.tabs.forEach((tab, tabIndex) => {
      const isActive = tabIndex === index;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
    });

    this.panels.forEach((panel, panelIndex) => {
      const isActive = panelIndex === index;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });

    this.activeIndex = index;
    this.tabs[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    if (focus) this.tabs[index].focus({ preventScroll: true });
    requestAnimationFrame(this.updateOverflowState);
  }

  handleTabKeydown(event, index) {
    let targetIndex = index;

    if (event.key === 'ArrowRight') targetIndex = (index + 1) % this.tabs.length;
    else if (event.key === 'ArrowLeft') targetIndex = (index - 1 + this.tabs.length) % this.tabs.length;
    else if (event.key === 'Home') targetIndex = 0;
    else if (event.key === 'End') targetIndex = this.tabs.length - 1;
    else return;

    event.preventDefault();
    this.activateTab(targetIndex, true);
  }

  updateOverflowState() {
    if (!this.tabList || !this.previousButton || !this.nextButton) return;

    const hasOverflow = this.tabList.scrollWidth > this.tabList.clientWidth + 2;
    this.classList.toggle('has-tab-overflow', hasOverflow);
    this.previousButton.disabled = this.activeIndex === 0;
    this.nextButton.disabled = this.activeIndex === this.tabs.length - 1;
  }
}

if (!customElements.get('dl-page-compliance-information-m')) {
  customElements.define('dl-page-compliance-information-m', DlPageComplianceInformationLL);
}
